module.exports = __webpack_public_path__ + "static/img/18.c0f8b09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/18.jpg
// module id = qLrI
// module chunks = 0